/**
 * Component Registry for Amc Homeestead Theme
 * 
 * Extends the base theme-homestead theme registry with Amc Homeestead specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-theme-homestead/registry';
import { Hero } from './components/Hero';
import { HeroCallouts } from './components/HeroCallouts';
import { SocialConnect } from './components/SocialConnect';
import { FloorplansList } from './components/FloorplansList';
import { HeroSolidBG } from './components/HeroSolidBG';
import { Footer } from './components/Footer';
import { FeeGuide } from './components/FeeGuide';
import { PetPolicy } from './components/PetPolicy';
import { AHScheduler } from './components/AHScheduler';
import { ContactForm } from './components/ContactForm';
import { ContactMap } from './components/ContactMap';
import { FAQ } from './components/FAQ';
import { Header } from './components/Header';
import { ParallaxBanner } from './components/ParallaxBanner';
import { SpecialOfferBanner } from './components/SpecialOfferBanner';
import { ImageCallouts } from './components/ImageCallouts';
import { PropertyOverview } from './components/PropertyOverview';
import { AmenitiesList } from './components/AmenitiesList';
import { VirtualTourEmbed } from './components/VirtualTourEmbed';
import { GalleryGrid } from './components/GalleryGrid';
import { InteractiveMapSection } from './components/InteractiveMapSection';
import { PriceGuaranteePopup } from './components/PriceGuaranteePopup';
import { TruePriceGuarantee } from './components/TruePriceGuarantee';
import { AccessibilityStatement } from './components/AccessibilityStatement';

/**
 * Amc Homeestead specific component overrides.
 * These components have been customized for the Amc Homeestead brand.
 * 
 * Example:
 * import { Footer } from './components/Footer';
 * 
 * const amchomeesteadOverrides: Partial<ComponentRegistry> = {
 *   Footer,
 * };
 */
const amchomeesteadOverrides: Partial<ComponentRegistry> = {
  Hero,
  HeroCallouts,
  SocialConnect,
  FloorplansList,
  HeroSolidBG,
  Footer,
  FeeGuide,
  PetPolicy,
  AHScheduler,
  ContactForm,
  ContactMap,
  FAQ,
  Header,
  ParallaxBanner,
  SpecialOfferBanner,
  ImageCallouts,
  PropertyOverview,
  AmenitiesList,
  VirtualTourEmbed,
  GalleryGrid,
  InteractiveMapSection,
  PriceGuaranteePopup,
  TruePriceGuarantee,
  AccessibilityStatement,
};

/**
 * Final merged registry for Amc Homeestead properties.
 * Inherits all components from the theme-homestead theme, with Amc Homeestead overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...amchomeesteadOverrides,
};

export default registry;
